<template>
    <v-content>
      <FirstView />
      <HomeContents />
      <Footer/>
    </v-content>
</template>

<script>
import FirstView from "@/components/FirstView";
import HomeContents from "@/components/HomeContents";
import Footer from "@/components/Footer";
export default {
  name: "App",
  data() {
    return {};
  },
  components: {
    FirstView,
    HomeContents,
    Footer
  }
};
</script>
